export default import.meta.ROLLUP_FILE_URL_Iefc__SZkyQq9XKQNWCHMQ